import React from 'react';

export default function CartPayments({payments}) {
  return (
    <div className="app-payments">
      {payments.filter(payment => !payment.isHidden).map((payment, paymentIndex) => {
        const {
          src,
          alt,
          height,
          width
        } = payment;

        return (
          <div className="app-payment-item" key={paymentIndex}>
            <img
              src={src}
              alt={alt}
              height={height}
              width={width}
            />
          </div>
        )
      })}
    </div>
  )
}
